import React from 'react';
import { extractPdfRedirectData } from '@utils/command';
import { ChevronRightIcon } from '@assets/icon';
import { Dropdown } from '@components/Dropdown';
import './CommandsList.scss';
import { CommandType } from '../../../../types/chat-agent';

interface CommandsListProps {
  commands: any[];
  onCommandClick: (command: string, id?: number) => void;
  isLoading?: boolean;
  isThinking?: boolean;
}

const CommandsList: React.FC<CommandsListProps> = ({ commands, onCommandClick, isLoading, isThinking = false }) => {

  const getDropdownItems = (command: any) => {
    const redirectData = extractPdfRedirectData(command);
    if (!redirectData || !redirectData.items || redirectData.items.length === 0) return null;

    return redirectData.items.map((item: any, index: number) => ({
      key: String(index),
      label: item.title,
      onClick: () => window.open(item.uri, '_blank'),
      nextIcon: <ChevronRightIcon />
    }));
  };

  if (isLoading || !commands || commands.length === 0) {
    return null;
  }

  return (
    <div className="commands-list">
      {commands.map((command: any) => {
        const isRedirect = command.type === CommandType.REDIRECT;
        const dropdownItems = isRedirect ? getDropdownItems(command) : null;

        const buttonContent = (
          <button
            key={isRedirect && dropdownItems ? undefined : command.id}
            className={`command-item ${isThinking ? 'disabled' : ''}`}
            onClick={() => {
              if (!isThinking && !isRedirect) {
                onCommandClick(command.name, command.id);
              }
            }}
            disabled={isThinking}
          >
            {command.icon && <img src={command.icon} alt="" className="command-icon" />}
            <span>{command.name}</span>
          </button>
        );

        if (isRedirect && dropdownItems) {
          return (
            <Dropdown
              key={command.id}
              items={dropdownItems}
              placement="bottomLeft"
              width={280}
              overlayClassName="redirect-dropdown"
            >
              {buttonContent}
            </Dropdown>
          );
        }

        return buttonContent;
      })}
    </div>
  );
};

export default CommandsList;
